import React, { useContext } from 'react';
import { bool, func, arrayOf, string } from 'prop-types';
import { ButtonStyled } from '@nike/nike-design-system-components';
import { connect } from 'react-redux';

import { TableServerSideContext } from '~COMPONENTS/tableServerSide/TableServerSideContext';
import Modal from '../../../../modal/Modal';

import { MAX_CATALOG_INDEX } from '../../../catalogs/constants';
import { indexCatalog as indexCatalogAction } from '../../actions';

function IndexCatalogModal({ closeModal, isOpen, catalogIds, catalogNames, indexCatalog, onSuccess }) {
  const { refreshTableData } = useContext(TableServerSideContext);

  const title =
    catalogIds.length === 0 && catalogNames.length === 0
      ? 'Error: Too Many Catalogs Selected'
      : `Index ${catalogNames.length === 1 ? 'Catalog' : 'Catalogs'}?`;

  const content = () => {
    if (catalogIds.length === 0 && catalogNames.length === 0) {
      return <p>A maximum of {MAX_CATALOG_INDEX} catalogs can be indexed at a time. Please reduce your selection.</p>;
    }

    if (catalogNames.length === 0) {
      return <p>Loading catalogs...</p>;
    }

    return (
      <>
        <p style={{ marginBottom: '1rem' }}>
          Are you sure you wish to index the selected{' '}
          {catalogNames.length === 1 ? 'catalog in its current state' : 'catalogs in their current state'}?
        </p>
        <ul>
          {catalogNames.map(name => (
            <li key={name}>{name}</li>
          ))}
        </ul>
      </>
    );
  };

  const footer = ({ isLoading, toggleIsLoading }) => {
    if (catalogIds.length === 0 && catalogNames.length === 0) {
      return null;
    }

    const handleSubmit = async () => {
      toggleIsLoading(true, 'Indexing...');

      try {
        await Promise.all(catalogIds.map(id => indexCatalog(id)));

        refreshTableData();
        if (onSuccess) onSuccess();
      } catch (error) {
        console.error('Error indexing catalogs:', error);
      }

      toggleIsLoading(false);
      closeModal();
    };

    return (
      <>
        <ButtonStyled
          type='button'
          appearance='primary'
          className='responsive-button'
          onClick={handleSubmit}
          disabled={isLoading}
        >
          Yes
        </ButtonStyled>
        <ButtonStyled
          type='button'
          appearance='secondary'
          className='responsive-button'
          onClick={closeModal}
          disabled={isLoading}
        >
          Cancel
        </ButtonStyled>
      </>
    );
  };

  return <Modal title={title} content={content} footer={footer} isOpen={isOpen} closeModal={closeModal} />;
}

IndexCatalogModal.propTypes = {
  catalogIds: arrayOf(string).isRequired,
  catalogNames: arrayOf(string).isRequired,
  closeModal: func.isRequired,
  isOpen: bool,
  indexCatalog: func.isRequired,
  onSuccess: func
};

IndexCatalogModal.defaultProps = {
  isOpen: false,
  onSuccess: null
};

export default connect(null, {
  indexCatalog: indexCatalogAction
})(IndexCatalogModal);
